import React, {useContext, useEffect, useLayoutEffect, useState} from "react";
import {IStepQuiz} from "../../../interfaces/IStepQuiz";
import {AppContext} from "../../../App";
import {CardActionArea, FormControlLabel, IconButton, Radio, Snackbar} from "@material-ui/core";
import {AppService} from "../../../services/app.service";
import QuizHeader from "./QuizHeader";
import CloseIcon from "@material-ui/icons/Close";

function MultipleChoice(p: IStepQuiz) {
    const [open, setOpen] = useState<boolean>(false)
    const [alertMsg, setAlertMsg] = useState<string>("")
    const context = useContext(AppContext);

    let questionConfig: any = p.questionConfig;
    let choices = []
    let questionItems: any = Object.values(questionConfig)[0]

    console.log(questionConfig)
    console.log(questionItems)

    const [selectedChoice, setSelectedChoice] = useState<string>("");
    const handleChoice = (event: React.ChangeEvent<HTMLInputElement>) => {
        let choice: string = (event.target as HTMLInputElement).value
        setSelectedChoice(choice);
    };

    for(let i = 0; i < questionItems.length; i++){
        choices.push(
            <div key={i} className={(selectedChoice === `${questionItems[i]}`)  ? "choice-active" : "choice-default"}>
                <input type="radio" className="radio"
                       checked={selectedChoice === `${questionItems[i]}`}
                       value={`${questionItems[i]}`}
                       onChange={handleChoice}
                />
                <span className="radio-look"/>
                {questionItems[i]}
            </div>
        );
    }

    useEffect(()=> {
        async function getResponse(){
            let appService = new AppService();
            const existing_response = await appService.getQuizResponse(p.id);
            console.log(existing_response.data.payload.saved_response)
            setSelectedChoice(existing_response.data.payload.saved_response)
        }
        getResponse();
    }, [context]);

    useEffect(()=>{
        saveResponse(Number(context.currentWeekNo),
            Number(context.currentTaskNo),
            Number(context.currentStepNo),
            selectedChoice);
    },[selectedChoice])

    function saveResponse(weekNo: number, taskNo: number, stepNo: number, response: any) {
        let appService = new AppService();
        let result = appService.saveQuizResponse(response, p.id, `${weekNo}${taskNo}${stepNo}`);
        console.log(result)
    }

    function executeAction() {
        if(selectedChoice === null || selectedChoice === ""){
            setAlertMsg('Please select answer to proceed');
            setOpen(true);

        } else {
            p.moveNext()
        }
    }

    const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };


    return(
        <div className={'multiple-choice'}>
            <QuizHeader question={p.prompt}/>
            <div className={'choices'}>
                {choices}
            </div>

            <div className={'mc-quiz-action-area'}>
                <CardActionArea className={'transcript-previous-button'} onClick={p.moveBack}>
                    Previous
                </CardActionArea>
                <CardActionArea className={'transcript-button'} onClick={executeAction}>
                    {(p.buttonLabel) ? p.buttonLabel : "Next"}
                </CardActionArea>
            </div>
            <div className={'mobile-spacing'}/>
        </div>
    )
}

export default MultipleChoice;
